import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import FooterSmall from '@redturtle/iovisit-theme/components/layout/Footer/FooterSmall';
import FooterMain from '@redturtle/iovisit-theme/components/layout/Footer/FooterMain';

const messages = defineMessages({
  siteInfos: {
    id: 'Site infos',
    defaultMessage: 'Site infos',
  },
  cookieSettings: {
    id: 'Cookie settings',
    defaultMessage: 'Cookie settings',
  },
});

const Footer = () => {
  const intl = useIntl();
  const content = useSelector((state) => state.content.data);
  return (
    <>
      <SlotRenderer name="preview-image-caption" content={content} />
      <div
        id="iv--footer"
        role="contentinfo"
        aria-label={intl.formatMessage(messages.siteInfos)}
      >
        <FooterMain />
        <FooterSmall />
      </div>
    </>
  );
};

export default Footer;
